import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { DebugService as debug } from "@core/services/debug.service";
import { AuthService, LocationAccessPermission } from '@core/services/auth/auth.service';
import { map, Observable } from 'rxjs';
import { NavigationService } from '@core/services/navigation.service';

@Injectable({
    providedIn: 'root'
})
export class PermissionGuard implements CanActivate {

    protected guardName: string = 'Permission';

    constructor(
        private _auth: AuthService,
        private _router: Router,
        private _nav: NavigationService
    ) { }


    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {

        const requiredPermission: LocationAccessPermission | LocationAccessPermission[] = route.data?.requiredPermission || "write";

        return this._auth.activeUserPermissions$.pipe(
            map(() => {
                let hasPermission = false;
                if (Array.isArray(requiredPermission)) {
                    for (let permission of requiredPermission) {
                        hasPermission = this._auth.hasPermission(permission, { explicit: true });
                        if (hasPermission) break;
                    }
                } else {
                    hasPermission = this._auth.hasPermission(requiredPermission);
                }
                debug.log(`Guard - ${this.guardName}:`, { [requiredPermission.toString()]: hasPermission })
                if (!hasPermission) {
                    return this._router.createUrlTree([this._nav.ForbiddenPath])
                }
                return true;
            }))

    }

}
